/* Deskhero Field Notes — builds the "In this article" table of contents from the article's H2/H3 headings.
   The article renders fully without this script; the TOC simply stays hidden. */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  /* data-fn-open: expanded = always open, desktop_only = open from 1000px up, collapsed = closed. */
  function applyOpenMode(details) {
    var mode = details.getAttribute('data-fn-open') || 'desktop_only';
    if (mode === 'expanded') details.open = true;
    else if (mode === 'collapsed') details.open = false;
    else details.open = window.matchMedia('(min-width: 1000px)').matches;
  }

  function init() {
    document.querySelectorAll('[data-fn-products]').forEach(applyOpenMode);

    var toc = document.querySelector('[data-fn-toc]');
    var prose = document.querySelector('[data-fn-prose]');
    if (!toc || !prose) return;

    var headings = prose.querySelectorAll('h2, h3');
    if (headings.length < 2) return;

    var list = toc.querySelector('.fn-toc__list');
    var used = {};
    var links = [];

    headings.forEach(function (heading) {
      var text = heading.textContent.trim();
      if (!text) return;

      var id = heading.id || slugify(text) || 'section';
      if (used[id]) {
        used[id] += 1;
        id = id + '-' + used[id];
      } else {
        used[id] = 1;
      }
      heading.id = id;

      var item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'fn-toc__item--sub';

      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = text;
      item.appendChild(link);
      list.appendChild(item);
      links.push({ link: link, heading: heading });
    });

    toc.hidden = false;
    applyOpenMode(toc);

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (item) {
            item.link.removeAttribute('aria-current');
            if (item.heading === entry.target) item.link.setAttribute('aria-current', 'true');
          });
        });
      },
      { rootMargin: '0px 0px -70% 0px' }
    );

    links.forEach(function (item) {
      observer.observe(item.heading);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Deskhero Field Notes — full-screen media viewer for article bodies.
   Enabled by data-fn-lightbox on the article prose. Images open on click; videos get an expand button. */
(function () {
  var EXPAND_ICON =
    '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9.5 2.5h4v4M6.5 13.5h-4v-4M13.5 2.5 9 7M2.5 13.5 7 9"/></svg>';

  function largeSrc(img) {
    var src = img.currentSrc || img.src;
    try {
      var url = new URL(src, window.location.href);
      if (url.searchParams.has('width')) {
        url.searchParams.set('width', '2400');
        url.searchParams.delete('height');
        return url.toString();
      }
    } catch (e) {}
    return src;
  }

  function init() {
    var prose = document.querySelector('[data-fn-lightbox]');
    if (!prose || !window.HTMLDialogElement) return;

    var closeLabel = prose.getAttribute('data-fn-lightbox-close') || 'Close';
    var items = [];

    function captionFor(el) {
      var figure = el.closest('figure');
      var cap = figure && figure.querySelector('figcaption');
      if (cap && cap.textContent.trim()) return cap.textContent.trim();
      return el.getAttribute('alt') || '';
    }

    prose.querySelectorAll('img').forEach(function (img) {
      if (img.closest('a, button')) return;
      var index = items.length;
      items.push({ type: 'image', el: img, caption: captionFor(img) });
      img.classList.add('fn-zoomable');
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', (img.getAttribute('alt') || 'Image') + ' - view full screen');
      img.addEventListener('click', function () {
        open(index);
      });
      img.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(index);
        }
      });
    });

    prose.querySelectorAll('video, iframe').forEach(function (media) {
      var host = media.parentElement;
      if (!host || host.querySelector('.fn-expand')) return;
      var index = items.length;
      items.push({ type: media.tagName === 'VIDEO' ? 'video' : 'iframe', el: media, caption: captionFor(media) });
      host.classList.add('fn-expandable');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'fn-expand';
      button.setAttribute('aria-label', 'View video full screen');
      button.innerHTML = EXPAND_ICON;
      button.addEventListener('click', function () {
        open(index);
      });
      host.appendChild(button);
    });

    if (!items.length) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'fn-lightbox';
    dialog.setAttribute('aria-label', 'Media viewer');
    dialog.innerHTML =
      '<button type="button" class="fn-lightbox__close" data-fn-lb="close"></button>' +
      '<button type="button" class="fn-lightbox__nav fn-lightbox__nav--prev" data-fn-lb="prev" aria-label="Previous"><span aria-hidden="true">&#8249;</span></button>' +
      '<figure class="fn-lightbox__figure"><div class="fn-lightbox__stage"></div><figcaption class="fn-lightbox__caption"></figcaption></figure>' +
      '<button type="button" class="fn-lightbox__nav fn-lightbox__nav--next" data-fn-lb="next" aria-label="Next"><span aria-hidden="true">&#8250;</span></button>' +
      '<p class="fn-lightbox__count" aria-live="polite"></p>';
    document.body.appendChild(dialog);

    var close = dialog.querySelector('[data-fn-lb="close"]');
    close.setAttribute('aria-label', closeLabel);
    close.innerHTML = '<span aria-hidden="true">&times;</span>';

    var stage = dialog.querySelector('.fn-lightbox__stage');
    var caption = dialog.querySelector('.fn-lightbox__caption');
    var count = dialog.querySelector('.fn-lightbox__count');
    var prev = dialog.querySelector('[data-fn-lb="prev"]');
    var next = dialog.querySelector('[data-fn-lb="next"]');
    var current = 0;
    var opener = null;

    if (items.length < 2) {
      prev.hidden = true;
      next.hidden = true;
      count.hidden = true;
    }

    function render(index) {
      current = (index + items.length) % items.length;
      var item = items[current];
      stage.innerHTML = '';

      if (item.type === 'image') {
        var img = document.createElement('img');
        img.src = largeSrc(item.el);
        img.alt = item.el.getAttribute('alt') || '';
        stage.appendChild(img);
      } else if (item.type === 'video') {
        var video = document.createElement('video');
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        if (item.el.poster) video.poster = item.el.poster;
        item.el.querySelectorAll('source').forEach(function (source) {
          video.appendChild(source.cloneNode(true));
        });
        if (!video.children.length && item.el.currentSrc) video.src = item.el.currentSrc;
        stage.appendChild(video);
        item.el.pause();
      } else {
        var frame = document.createElement('iframe');
        frame.src = item.el.src;
        frame.allow = 'autoplay; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        frame.title = item.el.title || 'Video';
        stage.appendChild(frame);
      }

      caption.textContent = item.caption;
      caption.hidden = !item.caption;
      count.textContent = current + 1 + ' / ' + items.length;
    }

    function open(index) {
      opener = document.activeElement;
      render(index);
      dialog.showModal();
      document.documentElement.classList.add('fn-lightbox-open');
    }

    dialog.addEventListener('close', function () {
      stage.innerHTML = '';
      document.documentElement.classList.remove('fn-lightbox-open');
      if (opener && opener.focus) opener.focus();
    });

    dialog.addEventListener('click', function (event) {
      var action = event.target.closest('[data-fn-lb]');
      if (action) {
        var name = action.getAttribute('data-fn-lb');
        if (name === 'close') dialog.close();
        if (name === 'prev') render(current - 1);
        if (name === 'next') render(current + 1);
      } else if (event.target === dialog || event.target === stage || event.target.classList.contains('fn-lightbox__figure')) {
        dialog.close();
      }
    });

    dialog.addEventListener('keydown', function (event) {
      if (items.length < 2) return;
      if (event.key === 'ArrowLeft') render(current - 1);
      if (event.key === 'ArrowRight') render(current + 1);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
